import useFetch from "react-fetch-hook"

import { getApiUrl, useApiHostContext } from "~/api"
import { ApiContextFetchListUrl, ApiContextFetchOptionsListType, ApiContextType } from "~/api/types"

type apiFetchType = <T extends ApiContextFetchListUrl>(
  props: {
    url: T
    query: ApiContextFetchOptionsListType[T]
  },
  options?: RequestInit,
  depends?: any[],
) => [ApiContextType[T], boolean]

export const useApiFetch: apiFetchType = ({ url, query }, options, depends) => {
  const apiHost = useApiHostContext()
  const apiUrl = getApiUrl(apiHost, url, query)

  const { isLoading, data } = useFetch<any>(apiUrl, options, {
    depends,
  })

  return [data, isLoading]
}
